import LichThiDauFullSidebar from "@/components/LichThiDauFullSidebar";

export default function BangKeoKetQuaSidebar() {
  return <LichThiDauFullSidebar type="ketqua" />;
}
